import { useIsMobile } from "@circleco/compass/hooks/useIsMobile";

import { notificationActionType } from "@/react/components/Notifications/NotificationsList/List/Actions/ActionContent";
import { classNames } from "@/react/helpers/twMergeWithCN";
import type { Notification } from "@/react/types/Notification";

import { GroupUserImage } from "../../GroupUserImage";
import { Item } from "../../Item";
import { Actions } from "../../Item/Actions";
import { TimeStamp } from "../../TimeStamp";
import { UserImageWithIcon } from "../../UserImageWithIcon";

export const DefaultNotificationContent = ({
  notification,
  isMarkedAsRead = false,
}: {
  notification: Notification;
  isMarkedAsRead?: boolean;
}) => {
  const isMobile = useIsMobile();

  return (
    <div
      className={classNames(
        "flex items-center",
        notificationActionType(notification),
      )}
    >
      {notification.second_actor_name ? (
        <GroupUserImage notification={notification} />
      ) : (
        <UserImageWithIcon
          src={notification.actor_image || ""}
          name={notification.actor_name}
          action={notification.action}
          size="8"
        />
      )}
      <div
        className="flex w-full flex-col items-start space-y-1"
        data-testid="notification-details"
      >
        <Item notification={notification} />
        <TimeStamp createdAt={notification.created_at} />
      </div>
      <div
        className={classNames(
          "flex size-6 items-center justify-center",
          "lg:group-hover:hidden lg:group-has-[[data-popup-open]]:hidden",
        )}
      >
        {!notification.read_at && !isMarkedAsRead && (
          <span className="bg-messaging-info-blue inline-block size-2 rounded-full" />
        )}
      </div>
      {!isMobile && <Actions notification={notification} />}
    </div>
  );
};
